import React, { useState } from 'react';

import './floatingButton.scss';
import {ReactSVG} from "react-svg";
import ContactForm from '../contactForm/ContactForm';

function FloatingButton() {
    const [isFormOpen, setIsFormOpen] = useState(false)

    const handleClick = () => {
        setIsFormOpen(!isFormOpen)
    }

    return (
        <>
        { !isFormOpen &&
            <div className={'floating-icon'}>
                <button style={{width: '100%', height: '100%'}} onClick={handleClick}>
                    <ReactSVG style={{transform: 'translateY(2px)'}} src="/images/chat-icon.svg"/>
                </button>
            </div>
        }
        <ContactForm isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} />
        </>
    )
}

export default FloatingButton;
